import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getBasicInformationStart,
  getBasicInformationSuccess,
  getBasicInformationFailed,
} from "../redux/getBasicInformation";

import { getBasicInformationApi } from "core/http/service/personnelInformation";
import { resetFormEditBasicInformation } from "../redux/formEditBasicInformation";

function* getBasicInformationWork() {
  try {
    const res = yield call(getBasicInformationApi);

    yield put({
      type: getBasicInformationSuccess.type,
      payload: res,
    });

    yield put({
      type: resetFormEditBasicInformation.type,
    });
  } catch (error: any) {
    yield put({
      type: getBasicInformationFailed.type,
    });
  }
}

function* watchGetBasicInformation() {
  yield takeLatest(getBasicInformationStart.type, getBasicInformationWork);
}

export default function* getBasicInformationSaga() {
  yield all([watchGetBasicInformation()]);
}
